import type { PrimeVueConfiguration } from 'primevue'

import { enLocale } from '@/libs/primevue/locales/primevueEn.ts'
import { hrLocale } from '@/libs/primevue/locales/primevueHr.ts'
import { slLocale } from '@/libs/primevue/locales/primevueSl.ts'

export const changePrimevueLanguage = (primevue: { config: PrimeVueConfiguration }, language: string) => {
    if (!language || language === 'sl') primevue.config.locale = slLocale
    else if (language === 'en') primevue.config.locale = enLocale
    else if (language === 'hr') primevue.config.locale = hrLocale
}
